export default __webpack_public_path__ + "static/bg_top_service_02-f6da662f472b0fc5abfcdb98c9ad678a.mp4";